import { Component, OnInit } from '@angular/core';
import { PrintService } from 'src/app/core/services/print.service';
import { Contact } from 'src/app/shared/models/clients/contact';

@Component({
  selector: 'app-print-client-contacts',
  templateUrl: './print-client-contacts.component.html',
  styleUrls: ['./print-client-contacts.component.scss']
})
export class PrintClientContactsComponent implements OnInit {
  contacts: Contact[] = [];
  clientName: string;

  constructor(
    private printService: PrintService,
  ) {
    this.contacts = this.printService.data.contacts;
    this.clientName = this.printService.data.clientName;
  }

  ngOnInit(): void {
    this.printService.onDataReady('Client Contacts');
  }

}
